import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import FlowHistoryFieldValue from './FlowHistoryFieldValue';

const FlowHistoryFieldValueBridge = react2angular(FlowHistoryFieldValue, [
  'fieldType',
  'fieldValue'
]);

export default FlowHistoryFieldValueBridge;
